import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaTimes } from "react-icons/fa";

export default function BaseModal({
  open = false,
  setOpen,
  modalSize = "max-w-md sm:w-full",
  title = "",
  children,
  className,
  customButtonTitle = "",
  customButtonAction = null
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel
                className={`relative transform rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 ${modalSize} sm:py-6 ${className}`}>
                <div className="absolute top-0 right-0 hidden pt-4 pr-4 sm:block"></div>
                <div className="mt-3 text-center sm:mt-0 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="text-base font-semibold leading-6 text-gray-900 flex justify-between border-b px-6 pb-3">
                    <span className="capitalize">{title}</span>
                    <span className="flex gap-2 items-center">
                      {customButtonAction && (
                        <button
                          type="button"
                          className="rounded-md bg-gray-400 text-white hover:bg-gray-500 px-3 py-1 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                          onClick={() => customButtonAction()}>
                          <span>{customButtonTitle}</span>
                        </button>
                      )}
                      <button
                        type="button"
                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        onClick={() => setOpen(false)}>
                        <span className="sr-only">Close</span>
                        <FaTimes className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </span>
                  </Dialog.Title>
                  <div className="mt-2 px-6">{children}</div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
